module.exports = __webpack_public_path__ + "img/BIT_white13.d7833e3c.jpg";